import { useContext } from 'react';
import { AuthenticationContext } from '../providers/AuthenticationProvider';
function useAuthentication() {
    return useContext(AuthenticationContext);
}
export default useAuthentication;
